import { render, staticRenderFns } from "./mainCategoryProduct.vue?vue&type=template&id=3bcddcf3&scoped=true"
import script from "./mainCategoryProduct.vue?vue&type=script&lang=js"
export * from "./mainCategoryProduct.vue?vue&type=script&lang=js"
import style0 from "./mainCategoryProduct.vue?vue&type=style&index=0&id=3bcddcf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcddcf3",
  null
  
)

export default component.exports